import {
  Edit,
  OtherHorizontal,
  NavigateUp,
  Add,
  SizeA,
  SizeC,
  SizeB,
} from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { useRef, useState } from 'react';

import { Button } from '../../Button/Button';
import { Menu, MenuItem } from '../../Menus';
import { useOutsideAlerter } from '../../utils';

import styles from './OrganizationChartItem.module.scss';
import { OrganizationChartItemSize, Props } from './OrganizationChartItem.types';

export const OrganizationChartItem = ({
  title,
  subtitle,
  className,
  size,
  onTextChange,
  onSizeChange,
  addChild,
  addParent,
  deleteItem,
  isRoot,
  isDisplayMode,
}: Props) => {
  const sizeIconMapping = {
    SMALL: <SizeA />,
    MEDIUM: <SizeB />,
    BIG: <SizeC />,
  };

  const [isSelected, setIsSelected] = useState(false);
  const itemRef = useRef(null);
  const popupRef = useRef(null);
  useOutsideAlerter({
    ref: itemRef,
    secondRef: popupRef,
    action: () => {
      if (isSelected) {
        setIsSelected(false);
      }
    },
  });
  return (
    <div className={styles.container}>
      <div
        className={classnames(styles.itemContainer, className, {
          [styles.secondaryItemContainer]: size === OrganizationChartItemSize.MEDIUM,
          [styles.tertiaryItemContainer]: size === OrganizationChartItemSize.SMALL,
          [styles.selected]: isSelected,
          [styles.secondarySelected]: isSelected && size === OrganizationChartItemSize.MEDIUM,
          [styles.tertiarySelected]: isSelected && size === OrganizationChartItemSize.SMALL,
        })}
        onClick={() => (!isSelected && !isDisplayMode ? setIsSelected(true) : undefined)}
        ref={itemRef}
        style={{
          width:
            (title.length + 1) * 8 >= ((subtitle?.length ?? 0) + 1) * 6
              ? (title.length + 1) * 8 + 32 + 'px'
              : ((subtitle?.length ?? 0) + 1) * 6 + 32 + 'px',
        }}
      >
        <div
          className={classnames(styles.title, {
            [styles.secondaryTitle]: size !== OrganizationChartItemSize.BIG,
          })}
        >
          {isSelected ? (
            <input
              className={classnames(styles.titleTextInput, {
                [styles.secondaryTitleTextInput]: size !== OrganizationChartItemSize.BIG,
              })}
              style={{ width: (title.length + 1) * 8 + 'px' }}
              type="text"
              value={title}
              onChange={e => {
                onTextChange({ newText: e.currentTarget.value, isTitle: true });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  setIsSelected(false);
                }
              }}
            />
          ) : (
            title
          )}
        </div>
        <div
          className={classnames(styles.subtitle, {
            [styles.secondarySubTitle]: size !== OrganizationChartItemSize.BIG,
          })}
        >
          {isSelected ? (
            <input
              className={classnames(styles.subtitleTextInput, {
                [styles.secondarySubTitle]: size !== OrganizationChartItemSize.BIG,
              })}
              style={{ width: ((subtitle?.length ?? 0) + 1) * 6 + 'px' }}
              type="text"
              value={subtitle}
              onChange={e => {
                onTextChange({ newText: e.currentTarget.value, isTitle: false });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  setIsSelected(false);
                }
              }}
            />
          ) : (
            subtitle
          )}
        </div>
        {isSelected && (
          <div>
            <Button
              rounded
              size="small"
              ref={itemRef}
              className={styles.plusButton}
              onClick={() => {
                addChild();
                setIsSelected(false);
              }}
            >
              <Add />
            </Button>
          </div>
        )}
        {isSelected && (
          <div className={styles.toolBar}>
            <Menu
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
              transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              onClose={() => setIsSelected(false)}
              trigger={
                <Button variant="tertiary" className={styles.actionButtonContainer}>
                  <SizeA />
                </Button>
              }
            >
              <div ref={popupRef} style={{ display: 'contents' }}>
                {Object.values(OrganizationChartItemSize).map(
                  (sizeChoice: OrganizationChartItemSize) => {
                    return (
                      <MenuItem
                        onClick={() => onSizeChange({ newSize: sizeChoice })}
                        selected={size === sizeChoice}
                        keepOpenOnClick
                      >
                        {sizeIconMapping[sizeChoice]}
                      </MenuItem>
                    );
                  }
                )}
              </div>
            </Menu>
            <div className={styles.verticalSeparator} />
            {!isRoot && (
              <Menu
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                onClose={() => setIsSelected(false)}
                trigger={
                  <Button variant="tertiary" className={styles.actionButtonContainer}>
                    <OtherHorizontal />
                  </Button>
                }
              >
                <div ref={popupRef}>
                  <MenuItem
                    onClick={() => {
                      deleteItem();
                    }}
                  >
                    <Edit />
                    supprimer l'élément et ses enfants
                  </MenuItem>
                </div>
              </Menu>
            )}
          </div>
        )}
        {isSelected && isRoot && (
          <Button
            rounded
            size="small"
            ref={itemRef}
            className={styles.addParentButton}
            onClick={addParent}
          >
            <NavigateUp />
          </Button>
        )}
      </div>
    </div>
  );
};
